import React from "react";

const hasMenuWithId = (menuItems, parentId, targetId) => {
  const parentMenu = menuItems.find(item => item.id === parentId);

  return parentMenu.children.some(child => child.id === targetId) || false;
};

export default hasMenuWithId;


// WEBPACK FOOTER //
// ./components/common/HasMenuWithId.jsx